import * as React from "react";

import { Card, Checkbox, EditableText, H1, HTMLTable } from "@blueprintjs/core";
// import {handleBooleanChange} from "@blueprintjs/docs-theme";
import { css } from "glamor";

import {
	getAllParticipants,
	getTeams,
	setAbsent,
	setParticipantFirstname,
	setParticipantLastname,
	setTeamName,
} from "../api";
import { Participant, Team } from "../Interfaces";

import * as _ from "lodash";
import Loading from "src/Loading";

const styles = {
	container: css({}),
	table: css({ width: "100%", tableLayout: "fixed" }),
	td: css({ verticalAlign: "middle !important" }),
	tdId: css({ width: "50px !important" }),
	tdCheckboxes: css({ width: "180px" }),
	checkboxContainer: css({
		display: "flex",
		alignItems: "baseline",
		marginBottom: "-10px",
	}),
	teamBox: css({ marginBottom: "30px" }),
	teamName: css({ textAlign: "left", margin: "10px" }),
};

export default class ParticipantManager extends React.Component<
	{},
	{ participants: Participant[]; teams: Team[] }
> {
	public state = { participants: [] as Participant[], teams: [] as Team[] };
	public async componentDidMount() {
		const teams = await getTeams();
		const participants = await getAllParticipants();
		this.setState({ participants, teams });
	}

	private onParticipantLastnameConfirm = async (participantId: number, newLastname: string) => {
		if (newLastname) {
			await setParticipantLastname(participantId, newLastname);
		}
	};

	private onParticipantFirstnameConfirm = async (participantId: number, newFirstname: string) => {
		if (newFirstname) {
			await setParticipantFirstname(participantId, newFirstname);
		}
	};
	private onTeamNameConfirm = async (teamId: number, newTeamName: string) => {
		if (newTeamName) {
			await setTeamName(teamId, newTeamName);
		}
	};
	private toggleAbsent = async (
		participant: Participant,
		absent_role: string,
		repopprev: number
	) => {
		const participantIndex = this.state.participants.findIndex((p) => p.id === participant.id);
		const newParticipant = {
			...participant,
			[absent_role]: !participant[absent_role] as boolean,
		} as Participant;
		const newParticipants = this.state.participants;
		newParticipants[participantIndex] = newParticipant;
		const res = await setAbsent(participant.id, repopprev, newParticipant[absent_role] as boolean);
		if (res.success === true) {
			this.setState({
				participants: newParticipants,
			});
		}
	};

	public render() {
		const teams = _.sortBy(this.state.teams, ["name"]);
		const participants = this.state.participants;
		const teamsWithParticipants = teams.map((team) => {
			const participantsOfTeam = participants
				.filter((p) => p.team_id === team.id)
				.sort((a, b) => a.id - b.id);
			return { ...team, participantsOfTeam };
		});
		return (
			<div>
				<div {...styles.container}>
					{teams.length === 0 ? (
						<Loading />
					) : (
						teamsWithParticipants.map((team) => (
							<div key={team.id} {...styles.teamBox}>
								<Card>
									<H1 {...styles.teamName}>
										<EditableText
											defaultValue={team.name}
											placeholder={team.name}
											onConfirm={(teamName) => this.onTeamNameConfirm(team.id, teamName)}
										/>
									</H1>
									<HTMLTable {...styles.table} striped={true} key={team.id}>
										<thead>
											<tr>
												<th {...styles.td} {...styles.tdId}>
													ID
												</th>
												<th {...styles.td}>Lastname</th>
												<th {...styles.td}>FirstName</th>
												<th {...styles.td} {...styles.tdCheckboxes}>
													Absent (Rep, Opp, Rev)
												</th>
											</tr>
										</thead>
										<tbody>
											{team.participantsOfTeam.map((participant: Participant) => (
												<tr key={participant.id}>
													<td {...styles.tdId} {...styles.td}>
														{participant.id}
													</td>
													<td {...styles.td}>
														<EditableText
															defaultValue={participant.lastname}
															placeholder={participant.lastname}
															onConfirm={(participantLastname) =>
																this.onParticipantLastnameConfirm(
																	participant.id,
																	participantLastname
																)
															}
														/>
													</td>
													<td {...styles.td}>
														<EditableText
															defaultValue={participant.firstname}
															placeholder={participant.firstname}
															onConfirm={(participantFirstname) =>
																this.onParticipantFirstnameConfirm(
																	participant.id,
																	participantFirstname
																)
															}
														/>
													</td>
													<td {...styles.tdCheckboxes} {...styles.td}>
														<div {...styles.checkboxContainer}>
															<Checkbox
																onChange={async () =>
																	this.toggleAbsent(participant, "absent_report", 1)
																}
																checked={participant.absent_report}
															/>
															<Checkbox
																onChange={async () =>
																	this.toggleAbsent(participant, "absent_opposition", 2)
																}
																checked={participant.absent_opposition}
															/>
															<Checkbox
																onChange={async () =>
																	this.toggleAbsent(participant, "absent_review", 3)
																}
																checked={participant.absent_review}
															/>
														</div>
													</td>
												</tr>
											))}
										</tbody>
									</HTMLTable>
								</Card>
							</div>
						))
					)}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Backend/ParticipantManager.tsx